export default __webpack_public_path__ + "static/media/watch-video_en.bac0b24a.png";